import script from "./FormSuratPermohonanPengesahanPJO.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuratPermohonanPengesahanPJO.vue?vue&type=script&setup=true&lang=js"

import "./FormSuratPermohonanPengesahanPJO.vue?vue&type=style&index=0&id=52aa77d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52aa77d4"]])

export default __exports__